import { Routes, Route } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import EmployeeContext from 'domain/people/employee/EmployeeContext';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';
import EmployeePortal from './EmployeePortal';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import GenerateEmployeeDocument from '../empoyeeDocuments/createupdate/GenerateEmployeeDocument';
import EmployeeDocumentContextTemplate from '../empoyeeDocuments/EmployeeDocumentContextTemplate';
import ViewEmployeeDocument from '../empoyeeDocuments/view/ViewEmployeeDocument';
import { UPLOAD_EMPLOYEE_DOCUMENTS, READ_EMPLOYEE_DOCUMENTS } from '../empoyeeDocuments/constants';
import { EMPLOYEE_PORTAL_ROUTE_PATHS } from './constants';
import EmployeePortalCompliance from './compliance/List/EmployeePortalCompliance';
import ComplianceDocumentSignPage from '../compliance/complianceDocument/ComplianceDocumentSignPage';
import { READ_COMPLIANCE_REGISTRY_DOCUMENTS, ComplianceDocumentContext } from 'domain/shared/compliance';
import { EMPLOYEE_CREATE_POLICY_CONSENT, EMPLOYEE_PORTAL_PATH } from 'domain/shared/employee';

const EmployeePortalRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { getUserAlias } = useAuthenticationProvider();
  const userAlias = getUserAlias();

  return (
    <ProtectedRouter>
      <Routes>
        <Route
          path="/"
          element={
            <EmployeeContext id={userAlias || undefined}>
              <EmployeePortal />
            </EmployeeContext>
          }
        />

        <Route
          path={`/${EMPLOYEE_PORTAL_ROUTE_PATHS.DOCUMENTS}/generate/:documentPath`}
          element={
            <EmployeeContext permissionToCheck={UPLOAD_EMPLOYEE_DOCUMENTS}>
              <EmployeeDocumentContextTemplate>
                <GenerateEmployeeDocument isEmpoyeePortal />
              </EmployeeDocumentContextTemplate>
            </EmployeeContext>
          }
        />

        <Route
          path={`/${EMPLOYEE_PORTAL_ROUTE_PATHS.DOCUMENTS}/:documentPath`}
          element={
            <EmployeeContext permissionToCheck={READ_EMPLOYEE_DOCUMENTS}>
              <EmployeeDocumentContextTemplate>
                <ViewEmployeeDocument isEmpoyeePortal />
              </EmployeeDocumentContextTemplate>
            </EmployeeContext>
          }
        />

        <Route
          path={`/${EMPLOYEE_PORTAL_ROUTE_PATHS.COMPLIANCE}`}
          element={
            <EmployeeContext permissionToCheck={READ_COMPLIANCE_REGISTRY_DOCUMENTS}>
              <EmployeePortalCompliance />
            </EmployeeContext>
          }
        />

        <Route
          path={`/${EMPLOYEE_PORTAL_ROUTE_PATHS.POLICY_SIGN}/:policyPath`}
          element={
            <EmployeeContext permissionToCheck={EMPLOYEE_CREATE_POLICY_CONSENT}>
              <ComplianceDocumentContext>
                <ComplianceDocumentSignPage />
              </ComplianceDocumentContext>
            </EmployeeContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

EmployeePortalRouter.getRouterPath = () => `${EMPLOYEE_PORTAL_PATH}/*`;

export default EmployeePortalRouter;
